// src/services/userRoleService.js

import apiClient from "./apiClient";
const API_URL = `/doctor-visits`; // Use relative path since apiClient has baseURL

export const createVisit = async (visitData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, visitData);
  return response.data;
};

export const getAllWards = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(API_URL);
  return response.data;
};

export const getVisitsByAssignment = async (patientId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/assignment/${patientId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific doctor-visits assignment table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export const getVisitsByAdmission = async (admissionid) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/by-admission/${admissionid}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific doctor-visits table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export default {
  createVisit,
  getAllWards,
  getVisitsByAssignment,
  getVisitsByAdmission 
}